import { render, staticRenderFns } from "./GeneralLiveStatsSubChart.component.vue?vue&type=template&id=ddcf4dda&scoped=true&"
import script from "./GeneralLiveStatsSubChart.component.vue?vue&type=script&lang=js&"
export * from "./GeneralLiveStatsSubChart.component.vue?vue&type=script&lang=js&"
import style0 from "./GeneralLiveStatsSubChart.component.vue?vue&type=style&index=0&id=ddcf4dda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcf4dda",
  null
  
)

export default component.exports